import { toFloat } from '../core/utils';

const ACC_PRECISION = 4;

export function getTestModelIntentAcc(tm) { return tm?.data?.int && !tm?.data?.asr && toFloat(tm.intent, ACC_PRECISION) }
export function getTestModelSlotAcc(tm)   { return tm?.data?.ent && toFloat(tm.entity, ACC_PRECISION) }
export function getTestModelWRR(tm)       { return (typeof tm?.data?.asr == 'string'
                                                    ? tm.data.asr.split('\n')[1].split('\t')[0] : tm?.data?.asr?.WRR) }
export function getTestModelGenvAcc(tm)   { return tm?.data?.genv && toFloat(tm.genv_score, ACC_PRECISION) }
